<template>
    <div>
        Email templates
    </div>
</template>

<script>
export default {
  name: "EmailTemplates"
}
</script>

<style scoped>

</style>